<template>
  <div class="page">
    <div class="nav1">
      来访详情 
    </div>
    <div class="form" v-if="form">
      <div class="process" v-if="form.status < 0">
        {{ status[form.status] }}
        <p v-if="form.status == -1">{{ form.confirmRemark }}</p>
      </div>
      <div v-else>
        <van-steps :active-icon="form.status == 10 ? undefined : 'circle'"
          :active="form.status == 10 ? 3 : form.status == 0 ? 1 : form.status == 1 || form.status == 2 ? 2 : 0">
          <van-step>发起申请</van-step>
          <!-- <van-step>人脸认证</van-step> -->
          <van-step>企业审核</van-step>
          <van-step>申请通过</van-step>
        </van-steps>
      </div>
      <div v-if="form.status == 10" style="text-align:center;padding:10px">
        <qr :form="form"></qr>
        <div style="font-size:13px">点击二维码下载</div>
      </div>
      <van-form @submit="onSubmit" aria-autocomplete="false" v-if="form">

        <div class="sub-title">拜访时间</div>
        <div>

          <!-- 
          <van-field required :readonly="true" :disabled="!readonly" :clickable="false" v-model="form.day" name="day"
            label="来访日期" placeholder="请选择来访日期" :rules="[{ required: true, message: '请选择来访日期' }]"
            @click="showCalendar = true" /> -->

          <!-- <van-calendar v-if="!readonly" v-model="showCalendar" @confirm="onConfirm" /> -->

          <van-field required :readonly="true" :disabled="!readonly" :clickable="false" name="startTime"
            :formatter="formmatTime" v-model="form.startTime" label="开始时间" placeholder="选择开始时间"
            @click="showStartTimePicker = true" />

          <!-- <van-popup v-if="!readonly" v-model="showStartTimePicker" position="bottom">
            <van-datetime-picker type="time" @confirm="onConfirmTime('startTime', $event)" :value="form.startTime"
              @cancel="showStartTimePicker = false" />
          </van-popup> -->


          <!-- <van-field v-model="form.password" name="开始时间" label="开始时间" placeholder="请选择开始时间"
            :rules="[{ required: true, message: '请选择开始时间' }]" /> -->


          <van-field :readonly="true" :disabled="!readonly" :clickable="false" name="endTime" v-model="form.endTime"
            :formatter="formmatTime" label="结束时间" placeholder="请选择结束时间"
            :rules="[{ required: true, message: '请选择结束时间' }]" @click="showEndTimePicker = true" />

          <!-- <van-popup v-if="!readonly" v-model="showEndTimePicker" position="bottom">
            <van-datetime-picker type="time" @confirm="onConfirmTime('endTime', $event)" :value="form.endTime"
              @cancel="showEndTimePicker = false" />
          </van-popup> -->


        </div>


        <div class="sub-title">我要拜访</div>
        <div>
          <van-field :readonly="true" required :disabled="!readonly" v-model="form.toName" name="toName" label="姓名"
            placeholder="请输入被访问人姓名" :rules="[{ required: true, message: '' }]" />
          <van-field :readonly="true" required :disabled="!readonly" v-model="form.toMobile" name="toMobile" label="手机号"
            type="tel" placeholder="请输入被访问人手机号" :rules="[{ required: true, message: '' }]" />

        </div>
        <div class="sub-title">我的信息</div>
        <div>
          <van-field :readonly="true" :disabled="!readonly" required v-model="form.username" name="username" label="姓名"
            placeholder="请输入被姓名" :rules="[{ required: true, message: '' }]" />


          <!-- <van-field readonly required :disabled="!readonly" v-model="form.idcard" name="idcard" label="身份证"
            placeholder="请输入身份证" :rules="[{ required: true, message: '' }]" /> -->

          <van-field :readonly="readonly" required v-model="form.mobile" name="mobile" label="邮箱" placeholder="请输入邮箱"
            :rules="[{ required: true, message: '' }]" />

          <van-field :readonly="readonly" required v-model="form.comapny" name="company" label="公司" placeholder="请输入公司"
            :rules="[{ required: true, message: '' }]" />
          <van-field :readonly="readonly" v-model="form.vehicleNo" name="VehicleNo" label="车牌号" placeholder="请输入车牌号"
            :rules="[{ required: false, message: '' }]" />

          <van-field :readonly="readonly" required v-model="form.reason" name="reason" label="来访事由"
            placeholder="请输入来访事由" :rules="[{ required: true, message: '' }]" />

          <van-field :readonly="readonly" required name="attachments.a" label="健康码"
            :rules="[{ required: true, message: '请上传健康码' }]">
            <template #input>
              <van-uploader :readonly="readonly" :deletable="!readonly" :max-count="1" v-model="uploader1">
              </van-uploader>
            </template>
          </van-field>
          <van-field :readonly="readonly" required name="attachments.b" label="行程卡"
            :rules="[{ required: true, message: '请上传行程卡' }]">
            <template #input>
              <van-uploader :readonly="readonly" :deletable="!readonly" :max-count="1" v-model="uploader2" />
            </template>
          </van-field>


        </div>
        <div v-if="form.status == -1">
          <div style="margin: 16px;">
            <van-button round block type="info" :loading="loading" native-type="submit">重新提交
            </van-button>
          </div>
        </div>

      </van-form>
      <div v-if="form">
        <!-- <div v-if="form.status == 0">
          <div style="margin: 16px;">
            <van-button round block type="info" :loading="loading" @click="goToFaceVaild(form.applyId)"
              native-type="button">人脸认证
            </van-button>
          </div>
        </div> -->



        <div v-if="form.status == -1 || form.status == 0 || form.status == 1 || form.status == 2">
          <div style="margin: 16px;">
            <van-button round block type="info" @click="cancel(form.applyId)" native-type="button">
              取消申请
            </van-button>
          </div>
        </div>
      </div>


    </div>
    <div v-else class="form nodate loading">
      <van-loading />
    </div>
  </div>
</template>

<script>
import { NavBar, Calendar, DatetimePicker, Form, Uploader, Steps, Step } from 'vant'
import qr from './qr.vue'
import dayjs from 'dayjs'
export default {
  data() {
    return {
      status: { "-2": "申请已取消", "-1": "审核不通过", "0": "请进行人脸认证", "1": "请耐心等待审核", "2": "请耐心等待审核", "10": "" },
      readonly: true,
      showStartTimePicker: false,
      showEndTimePicker: false,
      showCalendar: false,
      checkbox: false,
      loading: false,
      finished: false,
      sureRule: false,
      error: null,
      list: [],
      uploader1: [],
      uploader2: [],
      form: null
    }
  },
  components: {
    'qr': qr,
    'van-form': Form,
    'van-nav-bar': NavBar,
    'van-calendar': Calendar,
    'van-datetime-picker': DatetimePicker,
    'van-uploader': Uploader,
    "van-steps": Steps,
    "van-step": Step
  },
  mounted() {
    this.onLoad(this.$route.query.id)
  },
  methods: {
    formmatTime(date) {
      return dayjs(date).format("YYYY/MM/DD HH:mm")
    },
    onLoad(id) {
      this.axios
        .get('apply/info', { params: { applyId: id } })
        .then(res => {
          if (res.errorCode == 0) {
            let { info, employee, main } = res.data;
            if (info.status == -1) {
              this.readonly = false;
            }
            this.form = {
              applyId: info.applyId,
              status: info.status,
              day: dayjs(info.vistorDay).format("YYYY/MM/DD"),
              startTime: info.vistorStartTime,
              endTime: info.vistorEndTime,
              toName: employee.name,
              toMobile: employee.mobile,
              reason: info.reason,
              vehicleNo: info.vehicleNo || (info.status == -1 ? "" : " "),
              comapny: info.company,
              mainid: main.appleyPersonnelId,
              username: main.name,
              mobile: main.mobile,
              idcard: main.idNumber,
              confirmRemark: info.confirmRemark,
            }

            var arr = main.attachment.split(',')
            this.uploader1 = [{ url: arr[0] }]
            this.uploader2 = [{ url: arr[1] }]
          } else {
            this.$dialog.alert({
              title: '系统提示',
              message: res.errorMessage
            })
          }
        })
        .catch(error => {
          console.log(error)
          this.$dialog.alert({
            title: '系统异常',
            message: error.message
          })
        })
    }
    ,
    onConfirm(date) {
      console.log(date);
      this.form.day = dayjs(date).format("YYYY/MM/DD")
      this.showCalendar = false;
    },
    onConfirmTime(type, time) {
      this.form[type] = time;
      this.showStartTimePicker = false;
      this.showEndTimePicker = false;
    },
    goToFaceVaild(id) {
      // this.$dialog.loading();
      this.loading = true
      let successUrl = encodeURIComponent(`${window.location.origin}/appointment/success?id=${id}`)
      let failedUrl = encodeURIComponent(`${window.location.origin}/appointment/info?id=${id}`)
      this.axios
        .get('baiduai/getVerifyUrl', { params: { applyId: id } })
        .then(res => {
          if (res.errorCode == 0) {
            console.log(res.data)
            let url = `https://brain.baidu.com/face/print/?token=${res.data}&successUrl=${successUrl}&failedUrl=${failedUrl}`;
            window.location.href = url;
          } else {
            this.loading = false
            this.$dialog.alert({
              title: '系统提示',
              message: res.errorMessage
            })
          }
        })
        .catch(error => {
          console.log(error)
          this.loading = false
          this.$dialog.alert({
            title: '系统异常',
            message: error.message
          })
        })
    },
    onSubmit(e) {
      console.log(e);
      let attachments = [];
      Object.keys(e).forEach(key => {
        if (key.startsWith('attachments.')) {
          attachments = [...attachments, ...e[key].map(t => { return { content: t.content, key: t.key } })]
          delete e[key];
        }
      })

      e.attachments = attachments;

      this.axios
        .post('apply/reapply', { ...this.form, ...e })
        .then(res => {
          if (res.errorCode == 0) {
            this.loading = false
            this.form = { ...this.form, status: 1 }
            // 跳转到下一步
          } else {
            this.loading = false
            this.$dialog.alert({
              title: '系统提示',
              message: res.errorMessage
            })
          }
        })
        .catch(error => {
          console.log(error)
          this.loading = false
          this.$dialog.alert({
            title: '系统异常',
            message: error.message
          })
        })
    },
    cancel(id) {
      let that = this;
      this.$dialog.alert({
        title: '系统提示',
        message: "确定要取消当前申请",
      }).then(res => {

        that.axios
          .post('apply/cancel', { ApplyId: id })
          .then(res => {
            if (res.errorCode == 0) {
              that.form = { ...that.form, status: -2 }
            } else {
              that.$dialog.alert({
                title: '系统异常',
                message: res.errorMessage
              })
            }
          })
          .catch(error => {
            that.$dialog.alert({
              title: '系统异常',
              message: error.message
            })
          })

      }).catch(res => {


      })


    },
    onClickLeft() { },
  }
}
</script>

<style scoped lang="less">
.page {
  min-height: 100vh;
  background: #3a88f2;
  box-sizing: border-box;

  .nav1 {
    height: 80px;
    color: #fff;
    line-height: 80px;
    text-indent: 10px;
    font-size: 24px;

    span {
      color: #2765b7;
      font-size: 20px;
    }
  }

  .process {
    text-align: center;
    line-height: 30px;
    font-size: 16px;
    background: #FFF;
    padding: 10px 0;

    p {
      font-size: 14px;
      color: red;
      margin: 0;
      padding: 0;
    }
  }

  .form {
    background: #f8f8f8;
    border-top-right-radius: 5px;
    border-top-left-radius: 5px;
    box-sizing: border-box;
    min-height: calc(100vh - 80px);
    width: 100%;
    padding-bottom: 10px;

    .sub-title {
      margin: 0;
      padding: 16px 16px 16px;
      color: #333333;
      font-weight: normal;
      font-size: 16px;
      line-height: 16px;
      font-weight: bold;
    }

    .rule {
      margin: 16px;
      display: flex;
      align-items: center;
      justify-content: center;

      a {
        color: #63a1f5;
      }
    }
  }

  .block {
    background: #FFF;
    width: 80%;
    margin: 0 auto;
    justify-content: center;
    padding: 30px 0;
    margin-top: 30px;
  }
}
</style>
